module.exports = __webpack_public_path__ + "static/media/test_audio.5abab2ad.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/images/test_audio.mp3
// module id = 1140
// module chunks = 0